import {QueryClient} from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,                 // 1 min “fresh”
            gcTime: 30 * 60_000,               // 30 min in cache (TanStack v5: gcTime, v4: cacheTime)
            refetchOnWindowFocus: false,       // no refetch quando torni sulla tab
            refetchOnReconnect: true,          // refetch se torna la rete
            refetchOnMount: false,             // se già in cache, non rifare appena monti
            retry: (failureCount, error: any) => {
                const status = error?.status ?? error?.response?.status;

                if (status === 401 || status === 403 || status === 404) return false;

                return failureCount < 1;
            },
        },
        mutations: {
            retry: (failureCount, error: any) => {
                const status = error?.status ?? error?.response?.status;
                if (status === 401 || status === 403 || status === 404) return false;
                return failureCount < 1;
            },
        },
    },
});
